// extracted by mini-css-extract-plugin
module.exports = {"tip-picker":"_3rMU4","tipPicker":"_3rMU4","custom-amount-input":"DRxjf","customAmountInput":"DRxjf"};